import styled from '@emotion/styled';
import { Backdrop } from '@mui/material';
import { scale } from 'theme';
import { StyledDiv } from 'theme/commonStyled';

export const StyledList = styled.div<{ isBold: boolean }>`
  padding: ${({ theme }): string => `${theme.space[4]}px ${theme.space[7]}px`};
  display: flex;
  justify-content: space-between;
  color: ${({ theme, isBold }): string =>
    theme.colors[isBold ? 'blue100' : 'ash80']};
  background: ${({ theme, isBold }): string =>
    theme.colors[isBold ? 'ghostWhite' : 'none']};
  font-size: ${({ theme }): string => theme.fontSizes[2]};
  font-family: ${({ theme, isBold }): string =>
    theme.fonts[isBold ? 'bold' : 'regular']};
`;

export const StyledDiscount = styled.div`
  padding: ${({ theme }): string => `${theme.space[10]}px ${theme.space[7]}px`};
  margin: ${({ theme }): string => `${theme.space[8]}px`};
  border: ${({ theme }): string => theme.borders[0]};
  border-radius: ${({ theme }): string => theme.radii.md};
  border-color: ${({ theme }): string => theme.colors.blue10};
`;

export const StyledForm = styled.form`
  display: flex;
  gap: ${({ theme }): string => `${theme.space[5]}px`};

  input {
    height: ${({ theme }): string => `${theme.space[15]}px`};
    outline: none;
    width: 100%;
    border: ${({ theme }): string => theme.borders[0]};
    border-radius: ${({ theme }): string => theme.radii.md};
    border-color: ${({ theme }): string => theme.colors.blue10};
    padding: ${({ theme }): string => `${theme.space[7]}px`};
    margin: 0;
  }
`;

export const StyledPay = styled(StyledDiv)`
  padding: ${({ theme }): string => `${theme.space[7]}px ${theme.space[8]}px`};
  height: ${scale(70)}px;
  box-shadow: ${({ theme }): string => `${theme.shadows.pay}`};
  position: fixed;
  bottom: 0;
  display: flex;
  background: #fff;
`;

export const StyledModal = styled.div<{ isContractModal?: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${({ isContractModal }): string =>
    isContractModal ? '90%' : '30rem'};
  background-color: #fff;
  padding: ${({ theme, isContractModal }): number =>
      isContractModal ? theme.sizes[8] : theme.sizes[12]}px
    1rem;
  border-radius: ${({ theme }): string => theme.radii.xl};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }): number => theme.sizes[8]}px;
  font-size: ${({ theme }): string => theme.fontSizes[5]};
  outline: none;
`;

export const StyledBackdrop = styled(Backdrop)`
  z-index: ${({ theme }): number => theme.zIndices[8]};
`;
